
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      items: [
        {
          image: "BikeFlights_assemble_FINAL-1",
          title: "Prepare For Bike Assembly",
          content: [
            "After shipping your bike with Bikeflights, you will need to reassemble it - It's easy!",
            "Gather your tools. You will need the following to build your bike:",
            "Knife or Sharp Edge",
            "Allen Wrenches",
            "Torx Wrenches",
            "Scissors or Clippers",
            "Center Lock Tool",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-2",
          title: "Open your bike box, bike bag, or bike case.",
          content: [
            "If you are shipping with our Bikeflights Box, it should be sealed with packing tape.",
            "Use a knife to carefully cut along the taped edge.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-3",
          title: "Remove your lid",
          content: [
            "Lay your bike bike box flat on the floor, remove the top, and set aside.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-4",
          title: "Detach Your Bike",
          content: [
            "Remove your wheel bags and remove your frame from the straps or bungees securing it in your bike box.",
            "Leave your bike in your bike box to begin assembly. Your bike box will provide a barrier between the floor and your bike.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-5",
          title: "Disconnect All Secured Parts",
          content: [
            "Clip all zip ties and disconnect your secured accessory bag, your seat post, and your handlebars from your bike.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-06",
          title: "Remove All Padding From Your Bike",
          content: [
            "Clip all zip ties and remove all padding from your frame, fork, handlebars, crank arms, and derailleur.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-07",
          title: "Install Your Seatpost",
          content: [
            "Insert your seat post into your seat tube. ",
            "Align and adjust to your previously marked saddle height. Tighten your seat clamp to your frame’s torque spec.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-08",
          title: "Secure Your Bike In A Bike Stand",
          content: [
            "Using a bike stand will make for quicker and easier assembly, but If you don’t have a bike stand, skip this step, and continue using your bike box as a barrier between the floor and your bike.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-10",
          title: "Mount Your Derailleur",
          content: [
            "Mount your derailleur to your derailleur hanger, connecting the first few threads.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-11",
          title: "Align And Tighten Your Derailleur ",
          content: [
            "With your derailleur loosely connected to your hanger,  rotate your derailleur until the B-Screw and B-Screw Tab sit higher than your derailleur hanger.",
            "Slowly tighten your derailleur mounting bolt to your hanger, catching the B-Screw tab  on the edge of derailleur hanger.",
          ],
        },

        {
          image: "BikeFlights_assemble_DRAFT-12",
          title: " Install Your Handle Bar",
          content: [
            "Center your handlebars and rotate them to your marked placement. ",
            "Tighten to your stem’s torque spec.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-13",
          title: " Install Your Accessories",
          content: [
            "Install your bottle cages, fenders, lights, GPS, and other accessories.",
            "Tightening to their proper torque specs.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-14",
          title: " Install Your Disc Brake Rotors",
          content: [
            "Install your disc brake rotors onto your hubs, and ensure that they are facing their proper direction.",
            "Tighten your disc brake rotors to your hub’s torque spec.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-15",
          title: " Install Your Wheels",
          content: [
            "Install your wheels into your bike frame, and secure with your thru axles or your skewers.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-16",
          title: " Install Your Pedals",
          content: [
            "Install your pedals in your crank arms. ",
            "Your right pedal is threaded regularly (clockwise to tighten), while your left pedal is reverse threaded (counter-clockwise to tighten.)",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-17",
          title: " Check Your Gears",
          content: [
            "Spin your crank arms with your rear wheel elevated, and cycle through your gears to ensure smooth shifting.",
            "Adjust if necessary.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-18",
          title: " Check Your Brakes",
          content: [
            "Spin your wheels to make sure your brakes are not rubbing.",
            "Squeeze your brake levers to ensure they are properly engaging.",
            "Adjust if necessary.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-19",
          title: " Check Your Assembled Bike",
          content: [
            "Double-check that all bolts are tightened properly and that your bike is safe to ride.",
          ],
        },

        {
          image: "BikeFlights_assemble_DRAFT-20",
          title: " Test Ride Your Completed Bike",
          content: [
            "With your helmet on, perform a short safe bike ride to test your bike.",
            "Bring your multitool to make tweaks and adjustments if necessary.",
          ],
        },

        {
          image: "BikeFlights_assemble_DRAFT-21",
          title: " Gather Your Packing Materials",
          content: [
            "Consolidate all of your packing foam, packing straps, bungees, zip ties, tape, accessory bags, and other items used for packing. ",
            "Keep all of these items in your bike box, bike bag, or bike case so that they are easy to find and ready to use for your next bike shipment.",
          ],
        },

        {
          image: "BikeFlights_assemble_FINAL-22",
          title: " Ride!",
          content: [
            "After your bike is safely built and tested, get out there and enjoy the ride!",
          ],
        },
      ],
    };
  },
});
